<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="indent-para"><a id="page_2"></a><em>Once upon a time as the children were sleeping, a spell was cast upon the lands. When we awoke from the night, this spell had us believe that only what we could see in the physical world was real.</em></p>
<p class="indent-para"><em>Under this spell, a magical, deep, rich, exciting way to experience life ended for all the children. For there is so much more to the world around us than what we can see with our ordinary eyes, hear with our ordinary ears, feel in our bodies beyond the sense of ordinary touch. And when we forgot this we forgot the magic of being alive.</em></p>
<p class="indent-para"><em>As the veils between the seen and unseen worlds closed, children learned how to survive instead of how to thrive. They grew into suspicious adults who lost the ability to trust others as they forgot about the power of love. They learned how to manipulate others and to compete to get what they wanted.</em></p>
<p class="indent-para"><em>But now the spell is wearing off. The adults who were once children are waking up and remembering the ways of the hidden world. And as new children are born, they come in and help the rest of us remember.</em></p>
<p class="indent-para"><em>The time has come to wake up from the trance. Wake up now!</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?1fa3dd1c